module.exports = __webpack_public_path__ + "Simple-Line-Icons.e3e11284f9104f12c315.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Works/Safetyminder/Safetyminder/Admin/src/assets/fonts/Simple-Line-Icons.woff2?v=2.4.0
// module id = ../../../../../src/assets/fonts/Simple-Line-Icons.woff2?v=2.4.0
// module chunks = styles